import React, { useState } from 'react';
import { exportToCsv } from '../../utils/exportCsv';
import './DataTable.css';

const DataTable = ({
  title,
  columns,
  data = [],
  loading = false,
  onAddNew,
  searchPlaceholder = "Search records...",
  globalSearchQuery = "",
  onSearchChange
}) => {
  const [localSearchTerm, setLocalSearchTerm] = useState('');

  const activeQuery = (globalSearchQuery !== undefined && globalSearchQuery !== "" ? globalSearchQuery : localSearchTerm).trim().toLowerCase();

  const handleInputChange = (e) => {
    const val = e.target.value;
    setLocalSearchTerm(val);
    if (onSearchChange) {
      onSearchChange(val);
    }
  };

  const handlePaste = (e) => {
    const pastedText = e.clipboardData ? e.clipboardData.getData('text') : '';
    if (pastedText) {
      const cleanText = pastedText.replace(/[\r\n]+/g, ' ').trim();
      setLocalSearchTerm(cleanText);
      if (onSearchChange) {
        onSearchChange(cleanText);
      }
    }
  };

  const handleClear = () => {
    setLocalSearchTerm('');
    if (onSearchChange) {
      onSearchChange('');
    }
  };

  const filteredData = data.filter((row) => {
    if (!activeQuery) return true;

    return Object.keys(row).some((key) => {
      const val = row[key];
      if (val === null || val === undefined) return false;
      if (typeof val === 'object') {
        return JSON.stringify(val).toLowerCase().includes(activeQuery);
      }
      return String(val).toLowerCase().includes(activeQuery);
    });
  });

  return (
    <div className="data-table-container">
      <div className="table-header-bar">
        <div className="header-info">
          <h3>{title}</h3>
          <span className="count-badge">{filteredData.length} records</span>
        </div>

        <div className="header-controls">
          <div className="table-search">
            <span className="search-icon" style={{ display: 'inline-flex', alignItems: 'center', color: '#94a3b8' }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
            </span>
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={globalSearchQuery !== "" ? globalSearchQuery : localSearchTerm}
              onChange={handleInputChange}
              onInput={handleInputChange}
              onPaste={handlePaste}
              autoComplete="off"
              spellCheck="false"
            />
            {(globalSearchQuery || localSearchTerm) && (
              <button
                onClick={handleClear}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: '0.85rem', padding: '0 4px', display: 'inline-flex', alignItems: 'center' }}
                title="Clear search"
                type="button"
              >
                ✕
              </button>
            )}
          </div>

          <button
            className="export-csv-btn"
            onClick={() => exportToCsv(title, columns, filteredData)}
            title="Download records as Excel / CSV"
            type="button"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 14px',
              background: 'rgba(59, 130, 246, 0.12)',
              border: '1px solid rgba(59, 130, 246, 0.3)',
              color: '#38bdf8',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '0.82rem'
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Export CSV
          </button>

          {onAddNew && (
            <button className="add-btn" onClick={onAddNew}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Add {title.slice(0, -1)}
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="table-loading">Loading records from server...</div>
      ) : filteredData.length === 0 ? (
        <div className="table-empty">No matching records found.</div>
      ) : (
        <div className="table-responsive-wrapper">
          <table className="custom-data-table">
            <thead>
              <tr>
                {columns.map((col) => (
                  <th key={col.key}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, index) => (
                <tr key={row.id || index}>
                  {columns.map((col) => (
                    <td key={col.key}>
                      {col.render ? (
                        col.render(row[col.key], row, index)
                      ) : col.key === 'status' ? (
                        <span className={`status-pill ${String(row[col.key]).toLowerCase()}`}>
                          {row[col.key]}
                        </span>
                      ) : col.key === 'total' || col.key === 'price' ? (
                        `₹${Number(row[col.key]).toLocaleString('en-IN')}`
                      ) : (
                        row[col.key] || '—'
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DataTable;
